// テスト
var _isTest = false;

//preload
import {preload} from "../include/module";
preload();


$(window).on('load' , function() {


});



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js